import { Injectable, Inject, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LocaleService } from '@app/core/i18n';
import { STATIC_BASE_PATH } from '@app/core/services/content/variables';

@Injectable()
export class ContentRepositoryService {
  protected basePath = 'static/';

  constructor(
    private httpClient: HttpClient,
    private localeService: LocaleService,
    @Optional()
    @Inject(STATIC_BASE_PATH)
    basePath: string
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
  }

  get(basename: string): Observable<any> {
    return this.httpClient.get<any>(this.buildPath(basename));
  }

  getHeader(): Observable<any> {
    return this.get('header');
  }

  getFooter(): Observable<any> {
    return this.get('footer');
  }

  getI18n(): Observable<any> {
    return this.get('I18N');
  }

  getSizeGuide(): Observable<any> {
    return this.get('sizeGuide');
  }

  getProductSalesCondition(): Observable<any> {
    return this.get('productSalesCondition');
  }

  private buildPath(basename: string): string {
    const locale = this.localeService.getLocale().toString();
    const region = this.localeService.getRegion();

    if (locale === undefined || region === undefined) {
      throw new Error('Undefined locale or region');
    }

    return `${this.basePath}${region}/${locale}/${basename}.json`;
  }
}
